import { emptyToolFlags, resolveToolFlags } from '@/shared/lib/toolFormFlags'

export function emptyFormData() {
  return {
    toolFields: {},
    audioLanguage: localStorage.getItem('audio_language') ?? '',
    reportLanguage: localStorage.getItem('report_language') ?? '',
    comment: '',
    template: 'select_template',
    uses_custom_template: false,
    urgent: false,
    ...emptyToolFlags(),
    isPrivate: false,
  };
}

export function formDataFromSubmit(data, toolName) {
  return {
    toolFields: (data.toolFieldsData || []).reduce((acc, field) => {
      acc[field.name] = field.value ?? '';
      return acc;
    }, {}),
    audioLanguage: data.audioLanguage ?? '',
    reportLanguage: data.reportLanguage ?? '',
    comment: data.comment ?? '',
    template: data.template ?? 'select_template',
    uses_custom_template: data.uses_custom_template ?? false,
    urgent: data.urgent ?? false,
    ...resolveToolFlags(toolName, data),
    isPrivate: data.isPrivate ?? false,
  };
}
